import { ContactTableFragment } from "~/__generated__/graphql"
import { Button } from "~/ui/button"
import { Tag } from "~/ui/tag"
import tagIcon from "~/images/icons/tag"

interface ContactTagCellProps {
  contact: ContactTableFragment
  onEditTags: (contact: ContactTableFragment) => void
}

export function ContactTagCell({ contact, onEditTags }: ContactTagCellProps) {
  const handleEditTags = (e: React.MouseEvent) => {
    e.stopPropagation()
    onEditTags(contact)
  }

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-1">
        {contact.tags && contact.tags.length > 0 ? (
          contact.tags.slice(0, 2).map((tag: any) => (
            <Tag key={tag.id} className="group-hover:!bg-postal-purple group-hover:!text-white">
              {tag.name}
            </Tag>
          ))
        ) : (
          <span className="text-sm text-muted-foreground">-</span>
        )}
        {contact.tags && contact.tags.length > 2 && (
          <span className="text-xs text-muted-foreground">+{contact.tags.length - 2} more</span>
        )}
      </div>
      <Button
        variant="outline"
        size="sm"
        className="ml-2 h-8 w-8 flex-shrink-0 p-0"
        onClick={handleEditTags}
      >
        <img src={tagIcon.src} alt="Edit tags" className="h-4 w-4" />
      </Button>
    </div>
  )
}
